const publicEnv =
  typeof process !== "undefined"
    ? process.env
    : ((import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {});

export const siteConfig = {
  companyName: "Latam Energy Services",
  // TODO: Reemplazar por la razon social legal confirmada.
  legalCompanyName: "Latam Energy Services S.A.C.",
  // TODO: Confirmar dominio final antes de producción.
  domain: "https://latamenergyservices.com",
  // TODO: Reemplazar por correo verificado.
  email: "fbellidoc@latamenergyservices.com",
  // TODO: Reemplazar por teléfono verificado.
  telephone: "+51 993 602 425",
  // TODO: Reemplazar por número WhatsApp verificado en formato internacional.
  whatsapp: "51993602425",
  // TODO: Reemplazar por dirección fiscal/comercial confirmada.
  address: "Latinoamérica",
  serviceAreas: ["Perú", "Latinoamérica"],
  // TODO: Confirmar horario comercial.
  businessHours: "Lunes a viernes, 8:00 a.m. - 6:00 p.m.",
  socials: {
    // TODO: Agregar URL real de LinkedIn.
    linkedin: "",
    // TODO: Agregar URL real de Facebook si aplica.
    facebook: ""
  },
  defaultSeoTitle: "Latam Energy Services | Ingeniería, automatización y energía industrial",
  defaultSeoDescription:
    "Soluciones de automatización industrial, instrumentación, control, energía y mantenimiento para operaciones industriales en Perú y Latinoamérica.",
  // TODO: Reemplazar por URL real de Google Maps.
  googleMapsUrl: "https://maps.google.com/?q=Lima%2C%20Perú",
  analytics: {
    gaId: publicEnv.VITE_GA_ID ?? "",
    gtmId: publicEnv.VITE_GTM_ID ?? "",
    clarityId: publicEnv.VITE_CLARITY_ID ?? ""
  },
  verification: {
    google: publicEnv.VITE_GOOGLE_SITE_VERIFICATION ?? "",
    bing: publicEnv.VITE_BING_SITE_VERIFICATION ?? ""
  }
} as const;

export const quoteMessage =
  "Hola, deseo solicitar una cotización para soluciones industriales de Latam Energy Services.";
